import downloadFile from '@chama/utils/functions/download-file';

export const START_FETCHING_ORDER_HISTORY = 'START_FETCHING_ORDER_HISTORY';
export const SUCCESS_FETCHING_ORDER_HISTORY = 'SUCCESS_FETCHING_ORDER_HISTORY';
export const ERROR_FETCHING_ORDER_HISTORY = 'ERROR_FETCHING_ORDER_HISTORY';
export const START_FETCHING_ORDER_PERIODS = 'START_FETCHING_ORDER_PERIODS';
export const SUCCESS_FETCHING_ORDER_PERIODS = 'SUCCESS_FETCHING_ORDER_PERIODS';
export const START_FETCHING_MORE_ORDER_PERIODS = 'START_FETCHING_MORE_ORDER_PERIODS';
export const SUCCESS_FETCHING_MORE_ORDER_PERIODS = 'SUCCESS_FETCHING_MORE_ORDER_PERIODS';
export const ERROR_FETCHING_MORE_ORDER_PERIODS = 'ERROR_FETCHING_MORE_ORDER_PERIODS';
export const ERROR_FETCHING_ORDER_PERIODS = 'ERROR_FETCHING_ORDER_PERIODS';
export const START_FETCHING_HISTORY_ORDER_DETAILS = 'START_FETCHING_HISTORY_ORDER_DETAILS';
export const SUCCESS_FETCHING_HISTORY_ORDER_DETAILS = 'SUCCESS_FETCHING_HISTORY_ORDER_DETAILS';
export const ERROR_FETCHING_HISTORY_ORDER_DETAILS = 'ERROR_FETCHING_HISTORY_ORDER_DETAILS';
export const START_DOWNLOADING_INVOICE = 'START_DOWNLOADING_INVOICE';
export const DOWNLOADING_INVOICE_SUCCESS = 'DOWNLOADING_INVOICE_SUCCESS';
export const DOWNLOADING_INVOICE_ERROR = 'DOWNLOADING_INVOICE_ERROR';
export const START_DOWNLOADING_PAYMENT_SLIP = 'START_DOWNLOADING_PAYMENT_SLIP';
export const DOWNLOADING_PAYMENT_SLIP_SUCCESS = 'DOWNLOADING_PAYMENT_SLIP_SUCCESS';
export const DOWNLOADING_PAYMENT_SLIP_ERROR = 'DOWNLOADING_PAYMENT_SLIP_ERROR';
export const START_FETCHING_NOTA_FISCAL_LINK = 'START_FETCHING_NOTA_FISCAL_LINK';
export const FETCHING_NOTA_FISCAL_LINK_SUCCESS = 'FETCHING_NOTA_FISCAL_LINK_SUCCESS';
export const FETCHING_NOTA_FISCAL_LINK_ERROR = 'FETCHING_NOTA_FISCAL_LINK_ERROR';
export const NOT_FOUND_ERROR_CODE = 'NOT_FOUND_ERROR_CODE';

export const fetchOrderPeriods = (dealerId, fetchMore) => {
  return (dispatch, getState, { api }) => {
    const success = type => periods =>
      dispatch({
        type,
        periods: periods.items,
        nextBatchHref: periods.nextBatch && periods.nextBatch.href,
        dealerId,
      });

    if (fetchMore) {
      const {
        orderHistory: { nextBatchHref },
      } = getState();

      dispatch({
        type: START_FETCHING_MORE_ORDER_PERIODS,
      });

      return api
        .fetchMoreOrderPeriods(nextBatchHref)
        .then(success(SUCCESS_FETCHING_MORE_ORDER_PERIODS))
        .catch(() => dispatch({ type: ERROR_FETCHING_MORE_ORDER_PERIODS }));
    }

    dispatch({
      type: START_FETCHING_ORDER_PERIODS,
    });

    return api
      .fetchOrderPeriods(dealerId)
      .then(success(SUCCESS_FETCHING_ORDER_PERIODS))
      .catch(() => dispatch({ type: ERROR_FETCHING_ORDER_PERIODS }));
  };
};

export const fetchOrderHistoryForPeriod = periodId => {
  return (dispatch, getState, { api }) => {
    const {
      orderHistory: { periods },
    } = getState();
    const {
      billableItems: { href },
    } = periods[periodId];
    const success = orders =>
      dispatch({
        type: SUCCESS_FETCHING_ORDER_HISTORY,
        periodId,
        orders: {
          nextBatchHref: orders.nextBatch && orders.nextBatch.href,
          list: orders.items,
        },
      });
    const error = () => dispatch({ type: ERROR_FETCHING_ORDER_HISTORY, periodId });

    dispatch({ type: START_FETCHING_ORDER_HISTORY, periodId });

    return api
      .fetchOrderHistoryForPeriod(href)
      .then(success)
      .catch(error);
  };
};

export const fetchMoreOrdersForPeriod = periodId => {
  return (dispatch, getState, { api }) => {
    const {
      orderHistory: { periods },
    } = getState();
    const { nextBatchHref } = periods[periodId];
    const success = orders =>
      dispatch({
        type: SUCCESS_FETCHING_ORDER_HISTORY,
        periodId,
        orders: {
          nextBatchHref: orders.nextBatch && orders.nextBatch.href,
          list: orders.items,
        },
      });
    const error = () => dispatch({ type: ERROR_FETCHING_ORDER_HISTORY, periodId });

    dispatch({ type: START_FETCHING_ORDER_HISTORY, periodId });

    return api
      .fetchMoreHistoryOrders(nextBatchHref)
      .then(success)
      .catch(error);
  };
};

export const fetchHistoryOrderDetail = (periodId, orderId) => {
  return (dispatch, getState, { api }) => {
    const {
      orderHistory: { periods },
    } = getState();
    const {
      order: { href },
    } = periods[periodId].orders[orderId];
    const success = orderDetails =>
      dispatch({
        type: SUCCESS_FETCHING_HISTORY_ORDER_DETAILS,
        periodId,
        orderId,
        orderDetails,
      });
    const error = () =>
      dispatch({
        type: ERROR_FETCHING_HISTORY_ORDER_DETAILS,
        periodId,
        orderId,
      });

    dispatch({
      type: START_FETCHING_HISTORY_ORDER_DETAILS,
      periodId,
      orderId,
    });

    return api
      .fetchHistoryOrderDetail(href)
      .then(success)
      .catch(error);
  };
};

export const downloadInvoice = (dealerId, periodTimestamp) => {
  return (dispatch, getState, { api }) => {
    const requestSucess = blob => {
      const fileName = `chama-nota-fiscal@${dealerId}.pdf`;

      downloadFile(blob, fileName);
      dispatch({ type: DOWNLOADING_INVOICE_SUCCESS });
    };

    const requestRejected = response => {
      if (response.status === 404) {
        return dispatch({ type: DOWNLOADING_INVOICE_ERROR, errorCode: NOT_FOUND_ERROR_CODE });
      }

      return dispatch({ type: DOWNLOADING_INVOICE_ERROR });
    };

    dispatch({ type: START_DOWNLOADING_INVOICE });

    return api
      .downloadInvoice(dealerId, periodTimestamp)
      .then(requestSucess, requestRejected)
      .catch(e => {
        throw new Error(e);
      });
  };
};

export const downloadPaymentSlip = (dealerId, periodTimestamp) => {
  return (dispatch, getState, { api }) => {
    const requestSucess = blob => {
      const fileName = `chama-boleto@${dealerId}.pdf`;

      downloadFile(blob, fileName);
      dispatch({ type: DOWNLOADING_PAYMENT_SLIP_SUCCESS });
    };

    const requestRejected = response => {
      if (response.status === 404) {
        return dispatch({ type: DOWNLOADING_PAYMENT_SLIP_ERROR, errorCode: NOT_FOUND_ERROR_CODE });
      }

      return dispatch({ type: DOWNLOADING_PAYMENT_SLIP_ERROR });
    };

    dispatch({ type: START_DOWNLOADING_PAYMENT_SLIP });

    return api
      .downloadPaymentSlip(dealerId, periodTimestamp)
      .then(requestSucess, requestRejected)
      .catch(e => {
        throw new Error(e);
      });
  };
};

export const getNotaFiscaLink = (dealerId, periodTimestamp) => {
  return (dispatch, getState, { api }) => {
    const requestSucess = response => {
      const { href } = response;
      const newTab = window.open(href, '_blank');

      if (newTab) {
        newTab.focus();
      } else {
        // New tab got blocked by Chrome/AdBlocker
        window.location = href;
      }

      dispatch({ type: FETCHING_NOTA_FISCAL_LINK_SUCCESS });
    };

    const requestRejected = response => {
      if (response.status === 404) {
        return dispatch({ type: FETCHING_NOTA_FISCAL_LINK_ERROR, errorCode: NOT_FOUND_ERROR_CODE });
      }

      return dispatch({ type: FETCHING_NOTA_FISCAL_LINK_ERROR });
    };

    dispatch({ type: START_FETCHING_NOTA_FISCAL_LINK });

    return api
      .getNotaFiscalLink(dealerId, periodTimestamp)
      .then(requestSucess, requestRejected)
      .catch(e => {
        throw new Error(e);
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/order-history.js